var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckDetails = function SvgCheckDetails(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bitmap Copy 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    rx: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-760.000000, -32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap-Copy-11",
    transform: "translate(760.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFF0E0",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)",
    id: "contact_phone-24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,3 L2,3 C0.9,3 0,3.9 0,5 L0,19 C0,20.1 0.9,21 2,21 L22,21 C23.1,21 23.99,20.1 23.99,19 L24,5 C24,3.9 23.1,3 22,3 Z M8,6 C9.66,6 11,7.34 11,9 C11,10.66 9.66,12 8,12 C6.34,12 5,10.66 5,9 C5,7.34 6.34,6 8,6 Z M14,18 L2,18 L2,17 C2,15 6,13.9 8,13.9 C10,13.9 14,15 14,17 L14,18 Z M17.85,14 L19.49,14 L21,16 L19.01,17.99 C17.7,17.01 16.73,15.61 16.28,14 C16.1,13.36 16,12.69 16,12 C16,11.31 16.1,10.64 16.28,10 C16.73,8.38 17.7,6.99 19.01,6.01 L21,8 L19.49,10 L17.85,10 C17.63,10.63 17.5,11.3 17.5,12 C17.5,12.7 17.63,13.37 17.85,14 L17.85,14 Z",
    id: "Shape",
    fill: "#FF8200"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckDetails);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-details.6aacacd9aaa061ab5ea7b5bfdb561266.svg";